import dayjs from 'dayjs';
import { PostUtil } from './post-util';
import { CommonHelper } from 'src/utils/commonHelper';

const brandTimeZone = CommonHelper.GetBrandTimeZone();

const facebookReelsConfiguration = PostUtil.ServiceConfigurations.FACEBOOK.REELS;
const facebookPostConfiguration = PostUtil.ServiceConfigurations.FACEBOOK.POST;
const facebookStoryConfiguration = PostUtil.ServiceConfigurations.FACEBOOK.STORY;
const instagramReelsConfiguration = PostUtil.ServiceConfigurations.INSTAGRAM.REELS;
const instagramPostConfiguration = PostUtil.ServiceConfigurations.INSTAGRAM.POST;
const instagramStoryConfiguration = PostUtil.ServiceConfigurations.INSTAGRAM.STORY;
const youtubeCommonConfiguration = PostUtil.ServiceConfigurations.YOUTUBE.COMMON;
const twitterPostConfiguration = PostUtil.ServiceConfigurations.TWITTER.POST;
const ThreadsPostConfiguration = PostUtil.ServiceConfigurations.THREADS.POST;
const youtubePostConfiguration = PostUtil.ServiceConfigurations.YOUTUBE.POST;
const youtubeShortsConfiguration = PostUtil.ServiceConfigurations.YOUTUBE.SHORTS;
const linkedinPostConfiguration = PostUtil.ServiceConfigurations.LINKEDIN.POST;
const gbusinessPostConfiguration = PostUtil.ServiceConfigurations.GBUSINESS.POST;
const pinterestPostConfiguration = PostUtil.ServiceConfigurations.PINTEREST.POST;
const tiktokPostConfiguration = PostUtil.ServiceConfigurations.TIKTOK.POST;
const blueskyPostConfiguration = PostUtil.ServiceConfigurations.BLUESKY.POST;

const FacebookBulkUploadConditions = (request, translate) => {
  let fbErrors = [];
  const validPostTypes = ['post', 'reels'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    fbErrors.push(
      translate
        ? translate('bulk_upload_errors.select_one_post_type', 'Please select only one post type (Post / Reels).')
        : 'Please select only one post type (Post / Reels).'
    );
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    fbErrors.push(
      translate
        ? translate(
            'bulk_upload_errors.provide_correct_post_type',
            'Please provide a correct post type (Post / Reels).'
          )
        : 'Please provide a correct post type (Post / Reels).'
    );
  }
  return fbErrors;
};

const InstagramBulkUploadConditions = (request, translate) => {
  let insErrors = [];
  const validPostTypes = ['post', 'reels', 'story'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    insErrors.push(
      translate
        ? translate(
            'bulk_upload_errors.select_one_post_type',
            'Please select only one post type (Post / Reels / Story).'
          )
        : 'Please select only one post type (Post / Reels / Story).'
    );
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    insErrors.push(
      translate
        ? translate(
            'bulk_upload_errors.provide_correct_post_type',
            'Please provide a correct post type (Post / Reels / Story).'
          )
        : 'Please provide a correct post type (Post / Reels / Story).'
    );
  }
  return insErrors;
};

const YoutubeBulkUploadConditions = (request) => {
  let ytErrors = [];
  const validPostTypes = ['shorts', 'video'];
  const validPrivacy = ['public', 'private', 'unlisted'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());
  const privacy = request?.privacy
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    ytErrors.push('Please select only one post type (Video / Shorts).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    ytErrors.push('Please provide a correct post type (Video / Shorts).');
  }

  if (privacy.length > 1) {
    ytErrors.push('Please select only one privacy type (Public / Private / Unlisted).');
  }

  const isValidPrivacy = privacy.every((type) =>
    validPrivacy.some((validprivacy) => validprivacy?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPrivacy) {
    ytErrors.push('Please provide a correct privacy type (Public / Private / Unlisted).');
  }
  return ytErrors;
};

const TiktokBulkUploadConditions = (request) => {
  let tkErrors = [];
  const validPostTypes = ['DIRECT_POST', 'UPLOAD_TO_INBOX'];
  const validPrivacy = ['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());
  const privacy = request?.privacy
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    tkErrors.push('Please select only one post type (UPLOAD_TO_INBOX / DIRECT_POST).');
  }
  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    tkErrors.push('Please provide a correct post type (UPLOAD_TO_INBOX / DIRECT_POST).');
  }
  if (privacy.length > 1) {
    tkErrors.push(
      'Please select only one privacy type (PUBLIC_TO_EVERYONE / MUTUAL_FOLLOW_FRIENDS / FOLLOWER_OF_CREATOR / SELF_ONLY).'
    );
  }

  const isValidPrivacy = privacy.every((type) =>
    validPrivacy.some((validprivacy) => validprivacy?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPrivacy) {
    tkErrors.push(
      'Please provide a correct privacy type (PUBLIC_TO_EVERYONE / MUTUAL_FOLLOW_FRIENDS / FOLLOWER_OF_CREATOR / SELF_ONLY).'
    );
  }
  return tkErrors;
};
const SnapChatBulkUploadConditions = (request) => {
  let tkErrors = [];
  const validPostTypes = ['PUBLIC_STORY', 'SPOTLIGHT','SAVED_STORY'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());
  const privacy = request?.privacy
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    tkErrors.push('Please select only one post type (PUBLIC_STORY /SPOTLIGHT/ SAVED_STORY).');
  }
  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    tkErrors.push('Please provide a correct post type (PUBLIC_STORY /SPOTLIGHT/ SAVED_STORY).');
  }

  return tkErrors;
};

const GbusinessBulkUploadConditions = (request) => {
  let gbErrors = [];
  const validPostTypes = ['STANDARD', 'OFFER', 'EVENT'];
  const validButtonTypes = ['None', 'BOOK', 'ORDER', 'LEARN_MORE', 'SIGN_UP', 'CALL'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());
  const buttonTypes = request?.button_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    gbErrors.push('Please select only one post type (STANDARD / OFFER / EVENT).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    gbErrors.push('Please provide a correct post type (STANDARD / OFFER / EVENT).');
  }
  if (buttonTypes.length > 1) {
    gbErrors.push('Please select only one button type (None / BOOK / ORDER / LEARN_MORE / SIGN_UP / CALL).');
  }

  const isValidButtonType = buttonTypes.every((type) =>
    validButtonTypes.some((validbuttontype) => validbuttontype?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidButtonType) {
    gbErrors.push('Please provide a correct button type (None / BOOK / ORDER / LEARN_MORE / SIGN_UP / CALL).');
  }
  return gbErrors;
};

const TwitterBulkUploadConditions = (request) => {
  let trErrors = [];
  const validPostTypes = ['post'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    trErrors.push('Please select only one post type (Post).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    trErrors.push('Please provide a correct post type (Post).');
  }
  return trErrors;
};
const ThreadsBulkUploadConditions = (request) => {
  let trErrors = [];
  const validPostTypes = ['post'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    trErrors.push('Please select only one post type (Post).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    trErrors.push('Please provide a correct post type (Post).');
  }
  return trErrors;
};
const BlueskyBulkUploadConditions = (request) => {
  let trErrors = [];
  const validPostTypes = ['post'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    trErrors.push('Please select only one post type (Post).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    trErrors.push('Please provide a correct post type (Post).');
  }
  return trErrors;
};

const LinkedinBulkUploadConditions = (request) => {
  let lnErrors = [];
  const validPostTypes = ['post'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    lnErrors.push('Please select only one post type (Post).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    lnErrors.push('Please provide a correct post type (Post).');
  }
  return lnErrors;
};

const PinterestBulkUploadConditions = (request) => {
  let ptErrors = [];
  const validPostTypes = ['post'];
  const postTypes = request?.post_type
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());
  const Boards = request?.board_id
    ?.toLowerCase()
    .split('/')
    .map((type) => type.trim());

  if (postTypes.length > 1) {
    ptErrors.push('Please select only one post type (Post).');
  }

  const isValidPostType = postTypes.every((type) =>
    validPostTypes.some((validType) => validType?.toLowerCase() === type?.toLowerCase())
  );

  if (!isValidPostType) {
    ptErrors.push('Please provide a correct post type (Post).');
  }

  if (Boards.length > 1) {
    ptErrors.push('Please select only one Board.');
  }
  return ptErrors;
};

const FacebookPostConditions = (request, translate) => {
  let fErrors = [];
  let isMultipleVideoFiles = request?.media_data?.filter((a) => a.media_type?.includes('VIDEO'))?.length > 1;
  let imageFiles = request.media_data?.filter((a) => a.media_type === 'IMAGE') || [];
  if (isMultipleVideoFiles) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.post.multiple_videos', "You can't post multiple videos.")
        : "You can't post multiple videos."
    );
  }
  if (imageFiles.length > facebookPostConfiguration.MAXIMAGECOUNT) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.post.max_images', 'Maximum 10 images allowed in a single Facebook post.')
        : 'Maximum 10 images allowed in a single Facebook post.'
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length > facebookPostConfiguration.MAXSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.post.max_video_length', 'Maximum video length for the post is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: facebookPostConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the post is ${facebookPostConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${facebookPostConfiguration.MAXSECONDS} seconds.`
        );
      }
      const { width, height } = videoFile.aspect_ratio;
      if (width < facebookPostConfiguration.MINWIDTH || height < facebookPostConfiguration.MINHEIGHT) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.post.min_resolution', 'Minimum resolution is {{minWidth}}x{{minHeight}}px. Your media is {{width}}x{{height}}px.', {
                minWidth: facebookPostConfiguration.MINWIDTH,
                minHeight: facebookPostConfiguration.MINHEIGHT,
                width,
                height,
              })
            : `Minimum resolution is ${facebookPostConfiguration.MINWIDTH}x${facebookPostConfiguration.MINHEIGHT}px. Your media is ${width}x${height}px.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > facebookPostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.post.max_video_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: facebookPostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${facebookPostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    }
  }
  for (let i = 0; i < imageFiles.length; i++) {
    const { width, height } = imageFiles[i].aspect_ratio;
    if (width > facebookPostConfiguration.MAXWIDTH || height > facebookPostConfiguration.MAXHEIGHT) {
      fErrors.push(
        translate
          ? translate('new_post_errors.facebook.post.max_resolution', 'Maximum resolution is {{maxWidth}}x{{maxHeight}}px. Your media is {{width}}x{{height}}px.', {
              maxWidth: facebookPostConfiguration.MAXWIDTH,
              maxHeight: facebookPostConfiguration.MAXHEIGHT,
              width,
              height,
            })
          : `Maximum resolution is ${facebookPostConfiguration.MAXWIDTH}x${facebookPostConfiguration.MAXHEIGHT}px. Your media is ${width}x${height}px.`
      );
    }
    if (
      imageFiles[i]?.file_size !== 0 &&
      imageFiles[i]?.file_size > facebookPostConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024
    ) {
      const size = (imageFiles[i].file_size / 1024 / 1024).toFixed(2);
      fErrors.push(
        translate
          ? translate('new_post_errors.facebook.post.max_image_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
              maxSize: facebookPostConfiguration.MAX_IMAGE_SIZE_MB,
              size,
            })
          : `Image size must be less than ${facebookPostConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
      );
    }
  }

  let link = request?.link?.trim();
  let hasMedia = request?.media_data?.length > 0;

  if (link && hasMedia) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.post.link_with_media', 'If a link is added, do not add photos or videos in the Facebook post.')
        : 'If a link is added, do not add photos or videos in the Facebook post.'
    );
  }
  if (link) {
    if (!CommonHelper.isValidUrl(link)) {
      fErrors.push(
        translate
          ? translate('new_post_errors.facebook.post.invalid_url', 'Please enter a valid URL.')
          : 'Please enter a valid URL.'
      );
    }
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.post.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }
  if (request?.description && request?.description?.length > facebookReelsConfiguration.DESCRIPTION_MAX) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.post.description_too_long', 'Your description is {{length}} characters long, but it should not exceed {{maxLength}} characters.', {
            length: request.description.length,
            maxLength: facebookReelsConfiguration.DESCRIPTION_MAX,
          })
        : `Your description is ${request.description.length} characters long, but it should not exceed ${facebookReelsConfiguration.DESCRIPTION_MAX} characters.`
    );
  }
  // Need to uncomment
  // let errorMessage = CommonHelper.CheckAspectRatioForVideo(request.media_data, facebookPostConfiguration.ASPECTRATIO);
  // if (errorMessage) {
  //     fErrors.push(errorMessage);
  // }
  return fErrors;
};

const FacebookReelsConditions = (request, translate) => {
  let fErrors = [];
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type?.includes('VIDEO'))?.length > 1;
  if (!request.media_data?.some((a) => a.media_type?.includes('VIDEO'))) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.reels.no_video', 'Please select any video to post a Reel.')
        : 'Please select any video to post a Reel.'
    );
  }
  if (isMultipleVideoFiles) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.reels.multiple_videos', "You can't post multiple videos as a Reel.")
        : "You can't post multiple videos as a Reel."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length < facebookReelsConfiguration.MINSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.reels.min_video_length', 'Minimum video length for the reels is {{minSeconds}} seconds. Please choose a video minimum of {{minSeconds}} seconds.', {
                minSeconds: facebookReelsConfiguration.MINSECONDS,
              })
            : `Minimum video length for the reels is ${facebookReelsConfiguration.MINSECONDS} seconds. Please choose a video minimum of ${facebookReelsConfiguration.MINSECONDS} seconds.`
        );
      }
      if (videoFile.video_length > facebookReelsConfiguration.MAXSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.reels.max_video_length', 'Maximum video length for the reels is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: facebookReelsConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the reels is ${facebookReelsConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${facebookReelsConfiguration.MAXSECONDS} seconds.`
        );
      }

      const { width, height } = videoFile.aspect_ratio;
      const aspectRatio = width / height;
      if (width < facebookReelsConfiguration.MINWIDTH || height < facebookReelsConfiguration.MINHEIGHT) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.reels.min_resolution', 'Minimum resolution is {{minWidth}}x{{minHeight}}px. Your media is {{width}}x{{height}}px.', {
                minWidth: facebookReelsConfiguration.MINWIDTH,
                minHeight: facebookReelsConfiguration.MINHEIGHT,
                width,
                height,
              })
            : `Minimum resolution is ${facebookReelsConfiguration.MINWIDTH}x${facebookReelsConfiguration.MINHEIGHT}px. Your media is ${width}x${height}px.`
        );
      }
      if (aspectRatio.toFixed(2) !== facebookReelsConfiguration.MAXASPECTRATIO.toFixed(2)) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.reels.invalid_aspect_ratio', 'Invalid aspect ratio. The required aspect ratio is {{requiredRatio}}:1 (9:16). Your aspect ratio is {{currentRatio}}:1.', {
                requiredRatio: facebookReelsConfiguration.MAXASPECTRATIO.toFixed(2),
                currentRatio: aspectRatio.toFixed(2),
              })
            : `Invalid aspect ratio. The required aspect ratio is ${facebookReelsConfiguration.MAXASPECTRATIO.toFixed(2)}:1 (9:16). Your aspect ratio is ${aspectRatio.toFixed(2)}:1.`
        );
      }
      if (videoFile.aspect_ratio.height <= facebookReelsConfiguration.MINHEIGHT) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.reels.min_height', 'Minimum height for the video is {{minHeight}} pixels. Please choose a video minimum of {{minHeight}} pixels.', {
                minHeight: facebookReelsConfiguration.MINHEIGHT,
              })
            : `Minimum height for the video is ${facebookReelsConfiguration.MINHEIGHT} pixels. Please choose a video minimum of ${facebookReelsConfiguration.MINHEIGHT} pixels.`
        );
      }
    }
  }
  if (request?.description?.length > facebookReelsConfiguration.DESCRIPTION_MAX) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.reels.description_too_long', 'Your description is {{length}} characters long, but it should not exceed {{maxLength}} characters.', {
            length: request.description.length,
            maxLength: facebookReelsConfiguration.DESCRIPTION_MAX,
          })
        : `Your description is ${request.description.length} characters long, but it should not exceed ${facebookReelsConfiguration.DESCRIPTION_MAX} characters.`
    );
  }
  if (isVideoFileAvailable && isImageFileAvailable) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.reels.mixed_media', "You can't post images and videos in Facebook.")
        : "You can't post images and videos in Facebook."
    );
  }
  // Need to uncomment
  // let errorMessage = CommonHelper.CheckAspectRatioForVideo(request.media_data, facebookReelsConfiguration.ASPECTRATIO);
  // if (errorMessage) {
  //     fErrors.push(errorMessage);
  // }
  return fErrors;
};

const FacebookStoryConditions = (request, translate) => {
  let fErrors = [];
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type?.includes('VIDEO')).length > 1;
  let isMultipleImageFiles = request.media_data?.filter((a) => a.media_type?.includes('IMAGE')).length > 1;
  if (!request.media_data?.length > 0) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.story.no_media', 'Please select any video or image to post a Story.')
        : 'Please select any video or image to post a Story.'
    );
  }
  if (isMultipleVideoFiles) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.story.multiple_videos', "You can't post multiple videos as a Story.")
        : "You can't post multiple videos as a Story."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length < facebookStoryConfiguration.MINSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.story.min_video_length', 'Minimum video length for the story is {{minSeconds}} seconds. Please choose a video minimum of {{minSeconds}} seconds.', {
                minSeconds: facebookStoryConfiguration.MINSECONDS,
              })
            : `Minimum video length for the story is ${facebookStoryConfiguration.MINSECONDS} seconds. Please choose a video minimum of ${facebookStoryConfiguration.MINSECONDS} seconds.`
        );
      }
      if (videoFile.video_length > facebookStoryConfiguration.MAXSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.story.max_video_length', 'Maximum video length for the story is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: facebookStoryConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the story is ${facebookStoryConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${facebookStoryConfiguration.MAXSECONDS} seconds.`
        );
      }

      const { width, height } = videoFile.aspect_ratio;
      const aspectRatio = width / height;
      if (width < facebookStoryConfiguration.MINWIDTH || height < facebookStoryConfiguration.MINHEIGHT) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.story.min_resolution', 'Minimum resolution is {{minWidth}}x{{minHeight}}px. Your media is {{width}}x{{height}}px.', {
                minWidth: facebookStoryConfiguration.MINWIDTH,
                minHeight: facebookStoryConfiguration.MINHEIGHT,
                width,
                height,
              })
            : `Minimum resolution is ${facebookStoryConfiguration.MINWIDTH}x${facebookStoryConfiguration.MINHEIGHT}px. Your media is ${width}x${height}px.`
        );
      }
      if (aspectRatio.toFixed(2) !== facebookStoryConfiguration.MAXASPECTRATIO.toFixed(2)) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.story.invalid_aspect_ratio', 'Invalid aspect ratio. The required aspect ratio is {{requiredRatio}}:1 (9:16). Your aspect ratio is {{currentRatio}}:1.', {
                requiredRatio: facebookStoryConfiguration.MAXASPECTRATIO.toFixed(2),
                currentRatio: aspectRatio.toFixed(2),
              })
            : `Invalid aspect ratio. The required aspect ratio is ${facebookStoryConfiguration.MAXASPECTRATIO.toFixed(2)}:1 (9:16). Your aspect ratio is ${aspectRatio.toFixed(2)}:1.`
        );
      }
      if (videoFile.aspect_ratio.height <= facebookStoryConfiguration.MINHEIGHT) {
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.story.min_height', 'Minimum height for the video is {{minHeight}} pixels. Please choose a video minimum of {{minHeight}} pixels.', {
                minHeight: facebookStoryConfiguration.MINHEIGHT,
              })
            : `Minimum height for the video is ${facebookStoryConfiguration.MINHEIGHT} pixels. Please choose a video minimum of ${facebookStoryConfiguration.MINHEIGHT} pixels.`
        );
      }
    }
  }
  if (isMultipleImageFiles) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.story.multiple_images', "You can't post multiple images as a Story.")
        : "You can't post multiple images as a Story."
    );
  } else {
    let imageFile = request.media_data?.find((a) => a.media_type === 'IMAGE');
    if (imageFile) {
      if (
        imageFile?.file_size !== 0 &&
        imageFile?.file_size > facebookStoryConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024
      ) {
        const size = (imageFile.file_size / 1024 / 1024).toFixed(2);
        fErrors.push(
          translate
            ? translate('new_post_errors.facebook.story.max_image_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                maxSize: facebookStoryConfiguration.MAX_IMAGE_SIZE_MB,
                size,
              })
            : `Image size must be less than ${facebookStoryConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
        );
      }
    }
  }
  if (isVideoFileAvailable && isImageFileAvailable) {
    fErrors.push(
      translate
        ? translate('new_post_errors.facebook.story.mixed_media', "You can't post images and videos in Facebook Stories.")
        : "You can't post images and videos in Facebook Stories."
    );
  }
  return fErrors;
};

const InstagramPostConditions = (request, translate) => {
  let iErrors = [];
  let videoFiles = request.media_data?.filter((a) => a.media_type === 'VIDEO') || [];
  let imageFiles = request.media_data?.filter((a) => a.media_type === 'IMAGE') || [];
  let isMultipleFiles = request.media_data?.filter((a) => a.media_type.includes('IMAGE')).length > 10;
  if (isMultipleFiles) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.post.multiple_files_exceed', "You can't post media files that exceed the limit.")
        : "You can't post media files that exceed the limit."
    );
  }
  if (videoFiles.length > 0) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.post.no_videos', 'Videos are not allowed in Instagram posts. Please use the Reels option for video content.')
        : 'Videos are not allowed in Instagram posts. Please use the Reels option for video content.'
    );
  }
  if (imageFiles.length > instagramPostConfiguration.MAXIMAGECOUNT) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.post.max_images', 'Maximum 10 images allowed in a single Instagram post.')
        : 'Maximum 10 images allowed in a single Instagram post.'
    );
  }

  for (let i = 0; i < imageFiles.length; i++) {
    const { width, height } = imageFiles[i].aspect_ratio;
    const aspectRatio = width / height;

    if (
      imageFiles[i]?.file_size !== 0 &&
      imageFiles[i]?.file_size > instagramReelsConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024
    ) {
      const size = (imageFiles[i].file_size / 1024 / 1024).toFixed(2);
      iErrors.push(
        translate
          ? translate('new_post_errors.instagram.post.max_image_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
              maxSize: instagramReelsConfiguration.MAX_IMAGE_SIZE_MB,
              size,
            })
          : `Image size must be less than ${instagramReelsConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
      );
    }

    if (aspectRatio < 0.8 || aspectRatio > 1.91) {
      iErrors.push(
        translate
          ? translate('new_post_errors.instagram.post.invalid_aspect_ratio', 'Image {{index}} has an invalid aspect ratio of {{ratio}}. The allowed range is 4:5 (0.8) to 1.91:1 (1.91).', {
              index: i + 1,
              ratio: aspectRatio.toFixed(2),
            })
          : `Image ${i + 1} has an invalid aspect ratio of ${aspectRatio.toFixed(2)}. The allowed range is 4:5 (0.8) to 1.91:1 (1.91).`
      );
    }
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.post.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }
  if (!hasAttachments) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.post.no_media', 'Please select at least one media item.')
        : 'Please select at least one media item.'
    );
  }
  if (request.description) {
    const hashtags = request.description.match(/#[\p{L}\p{N}_]+/gu) || [];
    if (hashtags.length > 30) {
      iErrors.push(
        translate
          ? translate('new_post_errors.instagram.post.too_many_hashtags', 'Your description contains {{count}} hashtags but only up to 30 are allowed.', {
              count: hashtags.length,
            })
          : `Your description contains ${hashtags.length} hashtags but only up to 30 are allowed.`
      );
    }
    if (request.description.length > instagramReelsConfiguration.DESCRIPTION_MAX) {
      iErrors.push(
        translate
          ? translate('new_post_errors.instagram.post.description_too_long', 'Your description is {{length}} characters long, but it should not exceed {{maxLength}} characters.', {
              length: request.description.length,
              maxLength: instagramReelsConfiguration.DESCRIPTION_MAX,
            })
          : `Your description is ${request.description.length} characters long, but it should not exceed ${instagramReelsConfiguration.DESCRIPTION_MAX} characters.`
      );
    }
  }
  return iErrors;
};

const InstagramReelsConditions = (request, translate) => {
  let iErrors = [];
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type?.includes('VIDEO')).length > 1;

  if (!request.media_data?.some((a) => a.media_type?.includes('VIDEO'))) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.reels.no_video', 'Please select any video to post a Reel.')
        : 'Please select any video to post a Reel.'
    );
  }
  if (isMultipleVideoFiles) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.reels.multiple_videos', "You can't post multiple videos as a Reel.")
        : "You can't post multiple videos as a Reel."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length > instagramReelsConfiguration.MAXSECONDS) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.reels.max_video_length', 'Maximum video length for the reels is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: instagramReelsConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the reels is ${instagramReelsConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${instagramReelsConfiguration.MAXSECONDS} seconds.`
        );
      }
      if (videoFile.video_length < instagramReelsConfiguration.MINSECONDS) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.reels.min_video_length', 'Minimum video length for the reels is {{minSeconds}} seconds. Please choose a video minimum of {{minSeconds}} seconds.', {
                minSeconds: instagramReelsConfiguration.MINSECONDS,
              })
            : `Minimum video length for the reels is ${instagramReelsConfiguration.MINSECONDS} seconds. Please choose a video minimum of ${instagramReelsConfiguration.MINSECONDS} seconds.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > instagramReelsConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.reels.max_video_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: instagramReelsConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${instagramReelsConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
      const { width, height } = videoFile.aspect_ratio;
      const aspectRatio = width / height;
      if (width > instagramReelsConfiguration.MAXWIDTH) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.reels.max_resolution', 'Maximum resolution is {{maxWidth}}px. Your media is {{width}}px.', {
                maxWidth: instagramReelsConfiguration.MAXWIDTH,
                width,
              })
            : `Maximum resolution is ${instagramReelsConfiguration.MAXWIDTH}px. Your media is ${width}px.`
        );
      }

      if (aspectRatio < 0.01 || aspectRatio > 10) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.reels.invalid_aspect_ratio', 'Video has an invalid aspect ratio of {{ratio}}. The required range is 0.01:1 to 10:1.', {
                ratio: aspectRatio.toFixed(2),
              })
            : `Video has an invalid aspect ratio of ${aspectRatio.toFixed(2)}. The required range is 0.01:1 to 10:1.`
        );
      }
    }
  }
  if (request.description) {
    const hashtags = request.description.match(/#[\p{L}\p{N}_]+/gu) || [];
    if (hashtags.length > 30) {
      iErrors.push(
        translate
          ? translate('new_post_errors.instagram.reels.too_many_hashtags', 'Your description contains {{count}} hashtags but only up to 30 are allowed.', {
              count: hashtags.length,
            })
          : `Your description contains ${hashtags.length} hashtags but only up to 30 are allowed.`
      );
    }
    if (request.description.length > instagramReelsConfiguration.DESCRIPTION_MAX) {
      iErrors.push(
        translate
          ? translate('new_post_errors.instagram.reels.description_too_long', 'Your description is {{length}} characters long, but it should not exceed {{maxLength}} characters.', {
              length: request.description.length,
              maxLength: instagramReelsConfiguration.DESCRIPTION_MAX,
            })
          : `Your description is ${request.description.length} characters long, but it should not exceed ${instagramReelsConfiguration.DESCRIPTION_MAX} characters.`
        );
    }
  }
  if (isVideoFileAvailable && isImageFileAvailable) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.reels.mixed_media', "You can't post images and videos in Instagram.")
        : "You can't post images and videos in Instagram."
    );
  }
  return iErrors;
};

const InstagramStoryConditions = (request, translate) => {
  let iErrors = [];
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type?.includes('VIDEO')).length > 1;
  let isMultipleImageFiles = request.media_data?.filter((a) => a.media_type?.includes('IMAGE')).length > 1;
  if (!request.media_data?.length > 0) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.story.no_media', 'Please select any video or image to post a Story.')
        : 'Please select any video or image to post a Story.'
    );
  }
  if (isMultipleVideoFiles) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.story.multiple_videos', "You can't post multiple videos as a Story.")
        : "You can't post multiple videos as a Story."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length > instagramStoryConfiguration.MAXSECONDS) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.story.max_video_length', 'Maximum video length for the story is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: instagramStoryConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the story is ${instagramStoryConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${instagramStoryConfiguration.MAXSECONDS} seconds.`
        );
      }
      const { width, height } = videoFile.aspect_ratio;
      const aspectRatio = width / height;
      if (width > instagramStoryConfiguration.MAXWIDTH || height > instagramStoryConfiguration.MAXHEIGHT) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.story.max_resolution', 'Maximum resolution is {{maxWidth}}x{{maxHeight}}px. Your media is {{width}}x{{height}}px.', {
                maxWidth: instagramStoryConfiguration.MAXWIDTH,
                maxHeight: instagramStoryConfiguration.MAXHEIGHT,
                width,
                height,
              })
            : `Maximum resolution is ${instagramStoryConfiguration.MAXWIDTH}x${instagramStoryConfiguration.MAXHEIGHT}px. Your media is ${width}x${height}px.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > instagramStoryConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.story.max_video_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: instagramStoryConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${instagramStoryConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
      if (
        aspectRatio < instagramStoryConfiguration.MIN_VIDEO_ASPECT_RATIO ||
        aspectRatio > instagramStoryConfiguration.MAX_VIDEO_ASPECT_RATIO
      ) {
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.story.invalid_aspect_ratio', 'Video has an invalid aspect ratio of {{ratio}}. The required range is 0.01:1 to 10:1.', {
                ratio: aspectRatio.toFixed(2),
              })
            : `Video has an invalid aspect ratio of ${aspectRatio.toFixed(2)}. The required range is 0.01:1 to 10:1.`
        );
      }
    }
  }
  if (isMultipleImageFiles) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.story.multiple_images', "You can't post multiple images as a Story.")
        : "You can't post multiple images as a Story."
    );
  } else {
    let imageFile = request.media_data?.find((a) => a.media_type === 'IMAGE');
    if (imageFile) {
      const { width, height } = imageFile?.aspect_ratio;
      const aspectRatio = width / height;
      if (
        imageFile?.file_size !== 0 &&
        imageFile?.file_size > instagramStoryConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024
      ) {
        const size = (imageFile.file_size / 1024 / 1024).toFixed(2);
        iErrors.push(
          translate
            ? translate('new_post_errors.instagram.story.max_image_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                maxSize: instagramStoryConfiguration.MAX_IMAGE_SIZE_MB,
                size,
              })
            : `Image size must be less than ${instagramStoryConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
        );
      }
    }
  }
  if (isVideoFileAvailable && isImageFileAvailable) {
    iErrors.push(
      translate
        ? translate('new_post_errors.instagram.story.mixed_media', "You can't post images and videos in Instagram.")
        : "You can't post images and videos in Instagram."
    );
  }
  return iErrors;
};

const TwitterPostConditions = (request, translate) => {
  let tErrors = [];
  let imageFiles = request.media_data?.filter((a) => a.media_type === 'IMAGE') || [];
  let videoFiles = request.media_data?.filter((a) => a.media_type === 'VIDEO') || [];

  // Check for required content
  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    tErrors.push(
      translate
        ? translate('new_post_errors.twitter.no_content', 'Please enter a description or add media.')
        : 'Please enter a description or add media.'
    );
  }

  if (imageFiles.length > 4) {
    tErrors.push(
      translate
        ? translate('new_post_errors.twitter.max_images', 'Only a maximum of {{maxCount}} images are allowed for a post.', {
            maxCount: twitterPostConfiguration.MAXIMAGECOUNT,
          })
        : `Only a maximum of ${twitterPostConfiguration.MAXIMAGECOUNT} images are allowed for a post.`
    );
  }

  if (videoFiles.length > 1) {
    tErrors.push(
      translate
        ? translate('new_post_errors.twitter.single_video', 'Only a single video is allowed for a post.')
        : 'Only a single video is allowed for a post.'
    );
  }

  if (imageFiles.length > 0 && videoFiles.length > 0) {
    tErrors.push(
      translate
        ? translate('new_post_errors.twitter.mixed_media', 'You cannot include both images and videos in a single Twitter post.')
        : 'You cannot include both images and videos in a single Twitter post.'
    );
  }

  if (request.description && request.description.length > 280) {
    tErrors.push(
      translate
        ? translate('new_post_errors.twitter.description_too_long', 'Twitter description should not exceed 280 characters.')
        : 'Twitter description should not exceed 280 characters.'
    );
  }

  // Image validations
  for (let i = 0; i < imageFiles.length; i++) {
    if (imageFiles[i]?.aspect_ratio) {
      const { width, height } = imageFiles[i].aspect_ratio;
      if (width < twitterPostConfiguration.IMAGE_MINWIDTH || height < twitterPostConfiguration.IMAGE_MINHEIGHT) {
        tErrors.push(
          translate
            ? translate('new_post_errors.twitter.image_min_dimensions', 'Image {{index}}: The minimum allowed dimensions are {{minWidth}}x{{minHeight}}. Your image is {{width}}x{{height}}.', {
                index: i + 1,
                minWidth: twitterPostConfiguration.IMAGE_MINWIDTH,
                minHeight: twitterPostConfiguration.IMAGE_MINHEIGHT,
                width,
                height,
              })
            : `Image ${i + 1}: The minimum allowed dimensions are ${twitterPostConfiguration.IMAGE_MINWIDTH}x${twitterPostConfiguration.IMAGE_MINHEIGHT}. Your image is ${width}x${height}.`
        );
      }
      if (width > twitterPostConfiguration.IMAGE_MAXWIDTH || height > twitterPostConfiguration.IMAGE_MAXHEIGHT) {
        tErrors.push(
          translate
            ? translate('new_post_errors.twitter.image_max_dimensions', 'Image {{index}}: The maximum allowed dimensions are {{maxWidth}}x{{maxHeight}}. Your image is {{width}}x{{height}}.', {
                index: i + 1,
                maxWidth: twitterPostConfiguration.IMAGE_MAXWIDTH,
                maxHeight: twitterPostConfiguration.IMAGE_MAXHEIGHT,
                width,
                height,
              })
            : `Image ${i + 1}: The maximum allowed dimensions are ${twitterPostConfiguration.IMAGE_MAXWIDTH}x${twitterPostConfiguration.IMAGE_MAXHEIGHT}. Your image is ${width}x${height}.`
        );
      }
    }

    if (
      imageFiles[i]?.file_size !== 0 &&
      imageFiles[i]?.file_size > twitterPostConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024
    ) {
      const size = (imageFiles[i].file_size / 1024 / 1024).toFixed(2);
      tErrors.push(
        translate
          ? translate('new_post_errors.twitter.image_max_size', 'Image {{index}} size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
              index: i + 1,
              maxSize: twitterPostConfiguration.MAX_IMAGE_SIZE_MB,
              size,
            })
          : `Image ${i + 1} size must be less than ${twitterPostConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
      );
    }
  }

  // Video validations
  if (videoFiles.length > 0) {
    videoFiles.forEach((videoFile, index) => {
      if (!videoFile?.video_length) {
        tErrors.push(
          translate
            ? translate('new_post_errors.twitter.video_length_unknown', 'Video {{index}}: Unable to determine video length.', {
                index: index + 1,
              })
            : `Video ${index + 1}: Unable to determine video length.`
        );
      } else {
        if (videoFile.video_length < twitterPostConfiguration.MINSECONDS) {
          tErrors.push(
            translate
              ? translate('new_post_errors.twitter.video_min_length', 'Video {{index}}: Minimum video length for Twitter is {{minSeconds}} seconds. Your video is {{length}} seconds.', {
                  index: index + 1,
                  minSeconds: twitterPostConfiguration.MINSECONDS,
                  length: videoFile.video_length,
                })
              : `Video ${index + 1}: Minimum video length for Twitter is ${twitterPostConfiguration.MINSECONDS} seconds. Your video is ${videoFile.video_length} seconds.`
          );
        }
        if (videoFile.video_length > twitterPostConfiguration.MAXSECONDS) {
          tErrors.push(
            translate
              ? translate('new_post_errors.twitter.video_max_length', 'Video {{index}}: Maximum video length for Twitter is {{maxSeconds}} seconds. Your video is {{length}} seconds.', {
                  index: index + 1,
                  maxSeconds: twitterPostConfiguration.MAXSECONDS,
                  length: videoFile.video_length,
                })
              : `Video ${index + 1}: Maximum video length for Twitter is ${twitterPostConfiguration.MAXSECONDS} seconds. Your video is ${videoFile.video_length} seconds.`
          );
        }
      }

      if (videoFile?.aspect_ratio) {
        const { width, height } = videoFile.aspect_ratio;
        if (width < twitterPostConfiguration.MINWIDTH || height < twitterPostConfiguration.MINHEIGHT) {
          tErrors.push(
            translate
              ? translate('new_post_errors.twitter.video_min_dimensions', 'Video {{index}}: The minimum allowed dimensions are {{minWidth}}x{{minHeight}}. Your video is {{width}}x{{height}}.', {
                  index: index + 1,
                  minWidth: twitterPostConfiguration.MINWIDTH,
                  minHeight: twitterPostConfiguration.MINHEIGHT,
                  width,
                  height,
                })
              : `Video ${index + 1}: The minimum allowed dimensions are ${twitterPostConfiguration.MINWIDTH}x${twitterPostConfiguration.MINHEIGHT}. Your video is ${width}x${height}.`
          );
        }
        if (width > twitterPostConfiguration.MAXWIDTH || height > twitterPostConfiguration.MAXHEIGHT) {
          tErrors.push(
            translate
              ? translate('new_post_errors.twitter.video_max_dimensions', 'Video {{index}}: The maximum allowed dimensions are {{maxWidth}}x{{maxHeight}}. Your video is {{width}}x{{height}}.', {
                  index: index + 1,
                  maxWidth: twitterPostConfiguration.MAXWIDTH,
                  maxHeight: twitterPostConfiguration.MAXHEIGHT,
                  width,
                  height,
                })
              : `Video ${index + 1}: The maximum allowed dimensions are ${twitterPostConfiguration.MAXWIDTH}x${twitterPostConfiguration.MAXHEIGHT}. Your video is ${width}x${height}.`
          );
        }
      }

      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > twitterPostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        tErrors.push(
          translate
            ? translate('new_post_errors.twitter.video_max_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: twitterPostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${twitterPostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    });
  }

  return tErrors;
};

const SnapChatPublicStoryConditions = (request, translate) => {
  const errors = [];
  const config = PostUtil.ServiceConfigurations.SNAPCHAT;
  const MB = 1024 * 1024;

  const pushError = (key, defaultMsg, params = {}) => {
    errors.push(translate ? translate(`new_post_errors.snapchat.public_story.${key}`, defaultMsg, params) : defaultMsg);
  };

  const mediaFiles = request.media_data || [];

  if (mediaFiles.length === 0) {
    pushError('no_media', 'Please add at least one image or video for Public Story.');
  }
  if (mediaFiles.length > config.COMMON.MAX_MEDIA_COUNT) {
    pushError('multiple_media_not_supported', 'Public Story supports only one media item.');
  }

  const media = mediaFiles[0];
  if (media) {
    if (media.media_type === 'VIDEO') {
      if (media.video_length < config.COMMON.VIDEO.MIN_SECONDS || media.video_length > config.COMMON.VIDEO.MAX_SECONDS) {
        pushError('video_duration', `Video duration must be between ${config.COMMON.VIDEO.MIN_SECONDS}-${config.COMMON.VIDEO.MAX_SECONDS} seconds (Current: ${media.video_length}s)`, { current: media.video_length });
      }
      if (media.aspect_ratio?.width < config.COMMON.VIDEO.MIN_WIDTH || media.aspect_ratio?.height < config.COMMON.VIDEO.MIN_HEIGHT) {
        pushError('video_min_resolution', 'Minimum resolution for video is 540x960px');
      }
    }

  }

  if (request.description && request.description.length > config.PUBLIC_STORY.DESCRIPTION_MAX) {
    pushError('description_too_long', `Description cannot exceed ${config.PUBLIC_STORY.DESCRIPTION_MAX} characters`);
  }

  return errors;
};

const SnapChatSavedStoryConditions = (request, translate) => {
  const errors = [];
  const config = PostUtil.ServiceConfigurations.SNAPCHAT;
  const pushError = (key, defaultMsg, params = {}) => {
    errors.push(translate ? translate(`new_post_errors.snapchat.saved_story.${key}`, defaultMsg, params) : defaultMsg);
  };

  const mediaFiles = request.media_data || [];

  if (mediaFiles.length === 0) pushError('no_media', 'Please add at least one media for Saved Story.');
  if (mediaFiles.length > config.COMMON.MAX_MEDIA_COUNT) {
    pushError('multiple_media_not_supported', 'Saved Story supports only one media item.');
  }

  if (request.title && request.title.length > config.SAVED_STORY.TITLE_MAX) {
    pushError('title_too_long', `Saved Story title cannot exceed ${config.SAVED_STORY.TITLE_MAX} characters`);
  }

  return errors;
};

const SnapChatSpotlightConditions = (request, translate) => {
  const errors = [];
  const config = PostUtil.ServiceConfigurations.SNAPCHAT;

  const pushError = (key, defaultMsg, params = {}) => {
    errors.push(
      translate 
        ? translate(`new_post_errors.snapchat.spotlight.${key}`, defaultMsg, params) 
        : defaultMsg
    );
  };

  const mediaFiles = request.media_data || [];

  // Media count check
  if (mediaFiles.length === 0) {
    pushError('no_media', 'Please add at least one video for Spotlight.');
  }

  if (mediaFiles.length > config.COMMON.MAX_MEDIA_COUNT) {
    pushError('multiple_media_not_supported', 'Spotlight supports only one media item.');
  }

  // === NEW: Spotlight does NOT support images ===
  const hasImage = mediaFiles.some((media) => media.media_type === 'IMAGE');
  if (hasImage) {
    pushError('image_not_supported', 'Spotlight only supports video. Images are not allowed.');
  }

  // Video validation (only if video exists)
  const media = mediaFiles[0];
  if (media && media.media_type === 'VIDEO') {
    if (media.video_length < config.COMMON.VIDEO.MIN_SECONDS || 
        media.video_length > config.COMMON.VIDEO.MAX_SECONDS) {
      pushError('video_duration', 
        `Video duration must be between ${config.COMMON.VIDEO.MIN_SECONDS}-${config.COMMON.VIDEO.MAX_SECONDS} seconds (Current: ${media.video_length}s)`, 
        { current: media.video_length }
      );
    }

    if (media.aspect_ratio?.width < config.COMMON.VIDEO.MIN_WIDTH || 
        media.aspect_ratio?.height < config.COMMON.VIDEO.MIN_HEIGHT) {
      pushError('video_min_resolution', 'Minimum resolution for Spotlight video is 540x960px');
    }
  }

  // Description length
  if (request.description && request.description.length > config.SPOTLIGHT.DESCRIPTION_MAX) {
    pushError('description_too_long', `Spotlight description cannot exceed ${config.SPOTLIGHT.DESCRIPTION_MAX} characters`);
  }

  return errors;
};

const ThreadsPostConditions = (request, translate) => {
  const MB = 1024 * 1024;

  const isValidAspectRatio = (width, height) => {
    if (!width || !height) return false;
    const ratio = width / height;
    return ratio >= ThreadsPostConfiguration.ASPECT_RATIO_MIN && ratio <= ThreadsPostConfiguration.ASPECT_RATIO_MAX;
  };

  const formatBytes = (bytes) => (bytes / MB).toFixed(2);

  const pushError = (errors, msg, key, params = {}) => {
    errors.push(
      translate
        ? translate(`new_post_errors.threads.${key}`, msg, params)
        : msg
    );
  };

  const errors = [];

  const hasMedia = Array.isArray(request.media_data) && request.media_data.length > 0;
  const hasDescription = !!request.description && request.description.trim().length > 0;

  if (!hasMedia && !hasDescription) {
    pushError(errors, 'Please enter a description or add at least one media item.', 'no_content');
  }

  if (hasDescription && request.description.length > ThreadsPostConfiguration.MAX_DESCRIPTION_CHARS) {
    pushError(
      errors,
      `Description must not exceed ${ThreadsPostConfiguration.MAX_DESCRIPTION_CHARS} characters (current: ${request.description.length}).`,
      'description_too_long',
      { maxChars: ThreadsPostConfiguration.MAX_DESCRIPTION_CHARS, current: request.description.length }
    );
  }

  const images = request.media_data?.filter((m) => m.media_type === 'IMAGE') || [];
  const videos = request.media_data?.filter((m) => m.media_type === 'VIDEO') || [];
  const totalMedia = images.length + videos.length;

  if (totalMedia > ThreadsPostConfiguration.MAX_TOTAL_MEDIA) {
    pushError(
      errors,
      `A Threads post can contain at most ${ThreadsPostConfiguration.MAX_TOTAL_MEDIA} media items.`,
      'max_media',
      { maxMedia: ThreadsPostConfiguration.MAX_TOTAL_MEDIA }
    );
  }

  if (totalMedia > 1 && totalMedia < ThreadsPostConfiguration.MIN_CAROUSEL_ITEMS) {
    pushError(
      errors,
      `Carousel posts require at least ${ThreadsPostConfiguration.MIN_CAROUSEL_ITEMS} items.`,
      'min_carousel',
      { minItems: ThreadsPostConfiguration.MIN_CAROUSEL_ITEMS }
    );
  }

  images.forEach((img, idx) => {
    const pos = idx + 1;

    if (img.format && !ThreadsPostConfiguration.IMAGE_FORMATS.includes(img.format.toUpperCase())) {
      pushError(
        errors,
        `Image ${pos}: Only JPEG and PNG formats are supported (found ${img.format}).`,
        'image_format',
        { index: pos, format: img.format }
      );
    }

    if (img.file_size && img.file_size > ThreadsPostConfiguration.IMAGE_MAX_SIZE_MB * MB) {
      pushError(
        errors,
        `Image ${pos}: Size must be ≤ ${ThreadsPostConfiguration.IMAGE_MAX_SIZE_MB} MB (current ${formatBytes(img.file_size)} MB).`,
        'image_max_size',
        { index: pos, maxSize: ThreadsPostConfiguration.IMAGE_MAX_SIZE_MB, size: formatBytes(img.file_size) }
      );
    }

    if (img.aspect_ratio) {
      const { width, height } = img.aspect_ratio;

      if (!isValidAspectRatio(width, height)) {
        pushError(
          errors,
          `Image ${pos}: Aspect ratio must be between ${ThreadsPostConfiguration.ASPECT_RATIO_MIN}:1 and ${ThreadsPostConfiguration.ASPECT_RATIO_MAX}:1 (current ${width}:${height}).`,
          'image_aspect_ratio',
          { index: pos, minRatio: ThreadsPostConfiguration.ASPECT_RATIO_MIN, maxRatio: ThreadsPostConfiguration.ASPECT_RATIO_MAX, width, height }
        );
      }

      if (width < ThreadsPostConfiguration.IMAGE_MIN_WIDTH) {
        pushError(
          errors,
          `Image ${pos}: Width is below the minimum ${ThreadsPostConfiguration.IMAGE_MIN_WIDTH}px (will be scaled up). Current: ${width}px.`,
          'image_min_width',
          { index: pos, minWidth: ThreadsPostConfiguration.IMAGE_MIN_WIDTH, width }
        );
      }
      if (width > ThreadsPostConfiguration.IMAGE_MAX_WIDTH) {
        pushError(
          errors,
          `Image ${pos}: Width exceeds the maximum ${ThreadsPostConfiguration.IMAGE_MAX_WIDTH}px (will be scaled down). Current: ${width}px.`,
          'image_max_width',
          { index: pos, maxWidth: ThreadsPostConfiguration.IMAGE_MAX_WIDTH, width }
        );
      }
    }
  });

  videos.forEach((vid, idx) => {
    const pos = idx + 1;

    if (vid.format && !ThreadsPostConfiguration.VIDEO_CONTAINERS.includes(vid.format.toUpperCase())) {
      pushError(
        errors,
        `Video ${pos}: Only MP4 or MOV containers are supported (found ${vid.format}).`,
        'video_format',
        { index: pos, format: vid.format }
      );
    }

    if (vid.file_size && vid.file_size > ThreadsPostConfiguration.VIDEO_MAX_SIZE_MB * MB) {
      pushError(
        errors,
        `Video ${pos}: Size must be ≤ ${ThreadsPostConfiguration.VIDEO_MAX_SIZE_MB} MB (current ${formatBytes(vid.file_size)} MB).`,
        'video_max_size',
        { index: pos, maxSize: ThreadsPostConfiguration.VIDEO_MAX_SIZE_MB, size: formatBytes(vid.file_size) }
      );
    }

    if (typeof vid.video_length !== 'number') {
      pushError(
        errors,
        `Video ${pos}: Unable to determine video length.`,
        'video_length_unknown',
        { index: pos }
      );
    } else {
      if (vid.video_length <= ThreadsPostConfiguration.VIDEO_MIN_DURATION_SEC) {
        pushError(
          errors,
          `Video ${pos}: Duration must be greater than ${ThreadsPostConfiguration.VIDEO_MIN_DURATION_SEC} seconds.`,
          'video_min_duration',
          { index: pos, minDuration: ThreadsPostConfiguration.VIDEO_MIN_DURATION_SEC }
        );
      }
      if (vid.video_length > ThreadsPostConfiguration.VIDEO_MAX_DURATION_SEC) {
        pushError(
          errors,
          `Video ${pos}: Duration exceeds the maximum ${ThreadsPostConfiguration.VIDEO_MAX_DURATION_SEC} seconds (5 min). Current: ${vid.video_length}s.`,
          'video_max_duration',
          { index: pos, maxDuration: ThreadsPostConfiguration.VIDEO_MAX_DURATION_SEC, current: vid.video_length }
        );
      }
    }

    if (vid.aspect_ratio) {
      const { width, height } = vid.aspect_ratio;

      if (!isValidAspectRatio(width, height)) {
        pushError(
          errors,
          `Video ${pos}: Aspect ratio must be between ${ThreadsPostConfiguration.ASPECT_RATIO_MIN}:1 and ${ThreadsPostConfiguration.ASPECT_RATIO_MAX}:1 (current ${width}:${height}).`,
          'video_aspect_ratio',
          { index: pos, minRatio: ThreadsPostConfiguration.ASPECT_RATIO_MIN, maxRatio: ThreadsPostConfiguration.ASPECT_RATIO_MAX, width, height }
        );
      }

      if (width > ThreadsPostConfiguration.VIDEO_MAX_WIDTH || height > ThreadsPostConfiguration.VIDEO_MAX_HEIGHT) {
        pushError(
          errors,
          `Video ${pos}: Resolution exceeds the max ${ThreadsPostConfiguration.VIDEO_MAX_WIDTH}x${ThreadsPostConfiguration.VIDEO_MAX_HEIGHT}. Current: ${width}x${height}.`,
          'video_max_resolution',
          { index: pos, maxWidth: ThreadsPostConfiguration.VIDEO_MAX_WIDTH, maxHeight: ThreadsPostConfiguration.VIDEO_MAX_HEIGHT, width, height }
        );
      }
    }
  });

  return errors;
};
const BlueskyPostConditions = (request, translate) => {
 const MB = 1024 * 1024;
    const errors = [];

    const pushError = (key, defaultMsg, params = {}) => {
        errors.push(
            translate
                ? translate(`new_post_errors.bluesky.${key}`, defaultMsg, params)
                : defaultMsg
        );
    };

    const hasMedia = Array.isArray(request.media_data) && request.media_data.length > 0;
    const hasDescription = !!request.description && request.description.trim().length > 0;

    // 1. Must have either text or media
    if (!hasMedia && !hasDescription) {
        pushError('no_content', 'Please enter a description or add at least one media item.');
    }

    // 2. Description length
    if (hasDescription && request.description.length > blueskyPostConfiguration.MAX_DESCRIPTION_CHARS) {
        pushError(
            'description_too_long',
            `Description must not exceed ${blueskyPostConfiguration.MAX_DESCRIPTION_CHARS} characters (current: ${request.description.length}).`,
            {
                maxChars: blueskyPostConfiguration.MAX_DESCRIPTION_CHARS,
                current: request.description.length
            }
        );
    }

    const images = request.media_data?.filter((m) => m.media_type === 'IMAGE') || [];
    const videos = request.media_data?.filter((m) => m.media_type === 'VIDEO') || [];
    const totalMedia = images.length + videos.length;

    // 3. Media count limits
    if (videos.length > blueskyPostConfiguration.MAX_VIDEOS) {
        pushError(
            'max_videos',
            `Bluesky allows only ${blueskyPostConfiguration.MAX_VIDEOS} video per post.`,
            { maxVideos: blueskyPostConfiguration.MAX_VIDEOS }
        );
    }

    if (images.length > blueskyPostConfiguration.MAX_IMAGES) {
        pushError(
            'max_images',
            `Bluesky allows maximum ${blueskyPostConfiguration.MAX_IMAGES} images per post.`,
            { maxImages: blueskyPostConfiguration.MAX_IMAGES }
        );
    }

    // 4. Validate Images
    images.forEach((img, idx) => {
        const pos = idx + 1;

        // Format check
        if (img.format && !blueskyPostConfiguration.SUPPORTED_IMAGE_FORMATS.includes(img.format.toUpperCase())) {
            pushError(
                'image_format',
                `Image ${pos}: Only JPEG and PNG are supported (found ${img.format}).`,
                { index: pos, format: img.format }
            );
        }

        // Size check (1MB limit)
       if (img.file_size && img.file_size > blueskyPostConfiguration.IMAGE_MAX_SIZE_BYTES) {
        const currentSizeMB = (img.file_size / MB).toFixed(2);

        pushError(
            'image_max_size',
            `Image ${pos}: Must be ≤ 8 MB (current ${currentSizeMB} MB). Bluesky has a strict 8MB limit per image.`,
            { 
                index: pos, 
                size: currentSizeMB 
            }
        );
    }
    });

    // 5. Validate Videos
    videos.forEach((vid, idx) => {
        const pos = idx + 1;


        // Size check
        if (vid.file_size && vid.file_size > blueskyPostConfiguration.VIDEO_MAX_SIZE_MB * MB) {
        const currentSizeMB = (vid.file_size / MB).toFixed(2);

        pushError(
            'video_max_size',
            `Video ${pos}: Size must be ≤ ${blueskyPostConfiguration.VIDEO_MAX_SIZE_MB} MB (current ${currentSizeMB} MB).`,
            { 
                index: pos, 
                size: currentSizeMB 
            }
        );
    }
      
      
    });

    return errors;
};

const YoutubePostConditions = (request, translate) => {
  let yErrors = [];
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type?.includes('VIDEO')).length > 1;

  if (!isVideoFileAvailable) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.no_video', 'Please select any video.')
        : 'Please select any video.'
    );
  }
  if (request.description && (request.description.includes('<') || request.description.includes('>'))) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.invalid_description', 'YouTube description should not contain angle brackets (< or >). Please remove them.')
        : 'YouTube description should not contain angle brackets (< or >). Please remove them.'
    );
  }
  if (isMultipleVideoFiles) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.multiple_videos', "You can't post multiple videos.")
        : "You can't post multiple videos."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length > youtubePostConfiguration.MAXSECONDS) {
        yErrors.push(
          translate
            ? translate('new_post_errors.youtube.max_video_length', 'Maximum video length for the post is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: youtubePostConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the post is ${youtubePostConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${youtubePostConfiguration.MAXSECONDS} seconds.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > youtubePostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        yErrors.push(
          translate
            ? translate('new_post_errors.youtube.max_video_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: youtubePostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${youtubePostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    }
  }
  if (isImageFileAvailable) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.no_images', "You can't post images in YouTube.")
        : "You can't post images in YouTube."
    );
  }
  if (!request.title) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.no_title', 'Please enter YouTube title.')
        : 'Please enter YouTube title.'
    );
  }
  if (request.title && request.title.length > youtubeCommonConfiguration.TITLE_MAX) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.title_too_long', 'YouTube titles should not exceed 100 characters.')
        : 'YouTube titles should not exceed 100 characters.'
    );
  }
  if (request.description && request.description.length > youtubeCommonConfiguration.DESCRIPTION_MAX) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.description_too_long', 'YouTube description should not exceed 5000 characters.')
        : 'YouTube description should not exceed 5000 characters.'
    );
  }
  let isThumbnailAvailable = request?.thumbnail;
  if (isVideoFileAvailable && isThumbnailAvailable && !CommonHelper.isValidImageUrl(isThumbnailAvailable)) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.invalid_thumbnail', 'Please enter a valid thumbnail URL.')
        : 'Please enter a valid thumbnail URL.'
    );
  }
  return yErrors;
};

const YoutubeShortsConditions = (request, translate) => {
  let yErrors = [];
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('VIDEO')).length > 1;

  if (request.description && (request.description.includes('<') || request.description.includes('>'))) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.invalid_description', 'YouTube description should not contain angle brackets (< or >). Please remove them.')
        : 'YouTube description should not contain angle brackets (< or >). Please remove them.'
    );
  }
  if (!isVideoFileAvailable) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.no_video_shorts', 'Please select any video to post a Shorts.')
        : 'Please select any video to post a Shorts.'
    );
  }
  if (isMultipleVideoFiles) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.multiple_videos_shorts', "You can't post multiple videos as a Shorts.")
        : "You can't post multiple videos as a Shorts."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      const { width, height } = videoFile.aspect_ratio || {};
      const aspectRatio = width && height ? width / height : null;

      // Aspect ratio validation
      if (aspectRatio !== null) {
        if (aspectRatio !== 1 && aspectRatio !== 9 / 16) {
          yErrors.push(
            translate
              ? translate('new_post_errors.youtube.invalid_aspect_ratio', 'Video dimensions are invalid. Only square (1:1) and portrait (9:16) aspect ratios are accepted for YouTube. Your video has an aspect ratio of {{ratio}}.', {
                  ratio: aspectRatio.toFixed(2),
                })
              : `Video dimensions are invalid. Only square (1:1) and portrait (9:16) aspect ratios are accepted for YouTube. Your video has an aspect ratio of ${aspectRatio.toFixed(2)}.`
          );
        }
      }
      if (videoFile.video_length > youtubeShortsConfiguration.MAXSECONDS) {
        yErrors.push(
          translate
            ? translate('new_post_errors.youtube.max_video_length_shorts', 'Maximum video length for the Shorts is {{maxSeconds}} seconds. Please choose a video maximum of {{maxSeconds}} seconds.', {
                maxSeconds: youtubeShortsConfiguration.MAXSECONDS,
              })
            : `Maximum video length for the Shorts is ${youtubeShortsConfiguration.MAXSECONDS} seconds. Please choose a video maximum of ${youtubeShortsConfiguration.MAXSECONDS} seconds.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > youtubePostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        yErrors.push(
          translate
            ? translate('new_post_errors.youtube.max_video_size_shorts', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: youtubePostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${youtubePostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    }
  }
  if (request.media_data?.length === 0) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.only_video_shorts', 'You can post only video in YouTube.')
        : 'You can post only video in YouTube.'
    );
  }
  if (!request.title) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.no_title_shorts', 'Please enter YouTube title.')
        : 'Please enter YouTube title.'
    );
  }
  if (request.title && request.title.length > youtubeCommonConfiguration.TITLE_MAX) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.title_too_long_shorts', 'YouTube titles should not exceed 100 characters.')
        : 'YouTube titles should not exceed 100 characters.'
    );
  }
  if (request.description && request.description.length > youtubeCommonConfiguration.DESCRIPTION_MAX) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.description_too_long_shorts', 'YouTube description should not exceed 5000 characters.')
        : 'YouTube description should not exceed 5000 characters.'
    );
  }
  if (isImageFileAvailable) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.no_images_shorts', "You can't post images in YouTube.")
        : "You can't post images in YouTube."
    );
  }
  let isThumbnailAvailable = request?.thumbnail;
  if (isVideoFileAvailable && isThumbnailAvailable && !CommonHelper.isValidImageUrl(isThumbnailAvailable)) {
    yErrors.push(
      translate
        ? translate('new_post_errors.youtube.invalid_thumbnail_shorts', 'Please enter a valid thumbnail URL.')
        : 'Please enter a valid thumbnail URL.'
    );
  }
  return yErrors;
};

const LinkedinPostConditions = (request, translate) => {
  let lErrors = [];
  let videoFiles = request.media_data && request.media_data?.filter((a) => a.media_type.includes('VIDEO'));
  let isMultipleVideoFiles = videoFiles?.length > 1;
  let imagesCount = request.media_data && request.media_data?.filter((a) => a.media_type.includes('IMAGE')).length;
  let altText = request.alert_text ? request.alert_text.split(',') : [];

  if (isMultipleVideoFiles) {
    lErrors.push(
      translate
        ? translate('new_post_errors.linkedin.multiple_videos', "You can't post multiple videos at a time.")
        : "You can't post multiple videos at a time."
    );
  } else if (videoFiles && videoFiles.length && videoFiles.length === 1 && imagesCount > 0) {
    lErrors.push(
      translate
        ? translate('new_post_errors.linkedin.video_with_images', 'You can only post one video at a time without images.')
        : 'You can only post one video at a time without images.'
    );
  } else if (!isMultipleVideoFiles && imagesCount > linkedinPostConfiguration.MAXIMAGECOUNT) {
    lErrors.push(
      translate
        ? translate('new_post_errors.linkedin.max_images', 'Only a maximum of {{maxCount}} images are allowed per post.', {
            maxCount: linkedinPostConfiguration.MAXIMAGECOUNT,
          })
        : `Only a maximum of ${linkedinPostConfiguration.MAXIMAGECOUNT} images are allowed per post.`
    );
  }
  if (videoFiles && videoFiles?.length > 0) {
    if (videoFiles[0]?.video_length > linkedinPostConfiguration.MAXSECONDS) {
      const maxMinutes = linkedinPostConfiguration.MAXSECONDS / 60;
      lErrors.push(
        translate
          ? translate('new_post_errors.linkedin.max_video_length', 'Maximum video length for the post is {{maxMinutes}} minutes. Please choose a video maximum of {{maxMinutes}} minutes.', {
              maxMinutes,
            })
          : `Maximum video length for the post is ${maxMinutes} minutes. Please choose a video maximum of ${maxMinutes} minutes.`
      );
    }

    if (
      videoFiles[0]?.aspect_ratio.width < linkedinPostConfiguration.MINWIDTH ||
      videoFiles[0]?.aspect_ratio.height < linkedinPostConfiguration.MINHEIGHT
    ) {
      lErrors.push(
        translate
          ? translate('new_post_errors.linkedin.video_min_dimensions', 'Video: The minimum allowed video dimensions are {{minWidth}}x{{minHeight}}. Your video is {{width}}x{{height}}.', {
              minWidth: linkedinPostConfiguration.MINWIDTH,
              minHeight: linkedinPostConfiguration.MINHEIGHT,
              width: videoFiles[0]?.aspect_ratio.width,
              height: videoFiles[0]?.aspect_ratio.height,
            })
          : `Video: The minimum allowed video dimensions are ${linkedinPostConfiguration.MINWIDTH}x${linkedinPostConfiguration.MINHEIGHT}. Your video is ${videoFiles[0]?.aspect_ratio.width}x${videoFiles[0]?.aspect_ratio.height}.`
      );
    }

    if (
      videoFiles[0]?.aspect_ratio.width > linkedinPostConfiguration.MAXWIDTH ||
      videoFiles[0]?.aspect_ratio.height > linkedinPostConfiguration.MAXHEIGHT
    ) {
      lErrors.push(
        translate
          ? translate('new_post_errors.linkedin.video_max_dimensions', 'Video: The maximum allowed video dimensions are {{maxWidth}}x{{maxHeight}}. Your video is {{width}}x{{height}}.', {
              maxWidth: linkedinPostConfiguration.MAXWIDTH,
              maxHeight: linkedinPostConfiguration.MAXHEIGHT,
              width: videoFiles[0]?.aspect_ratio.width,
              height: videoFiles[0]?.aspect_ratio.height,
            })
          : `Video: The maximum allowed video dimensions are ${linkedinPostConfiguration.MAXWIDTH}x${linkedinPostConfiguration.MAXHEIGHT}. Your video is ${videoFiles[0]?.aspect_ratio.width}x${videoFiles[0]?.aspect_ratio.height}.`
      );
    }
    if (
      videoFiles[0]?.file_size !== 0 &&
      videoFiles[0]?.file_size > linkedinPostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
    ) {
      const size = (videoFiles[0].file_size / 1024 / 1024).toFixed(2);
      lErrors.push(
        translate
          ? translate('new_post_errors.linkedin.video_max_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
              maxSize: linkedinPostConfiguration.MAX_VIDEO_SIZE_MB,
              size,
            })
          : `Video size must be less than ${linkedinPostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
      );
    }
  }

  if (request.description.length > linkedinPostConfiguration.DESCRIPTION_MAX) {
    lErrors.push(
      translate
        ? translate('new_post_errors.linkedin.description_too_long', 'Your description is {{length}} characters long, but it should not exceed {{maxLength}} characters.', {
            length: request.description.length,
            maxLength: linkedinPostConfiguration.DESCRIPTION_MAX,
          })
        : `Your description is ${request.description.length} characters long, but it should not exceed ${linkedinPostConfiguration.DESCRIPTION_MAX} characters.`
    );
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    lErrors.push(
      translate
        ? translate('new_post_errors.linkedin.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }
  for (let i = 0; i < altText.length; i++) {
    if (altText[i].length > linkedinPostConfiguration.ALTER_TEXT_MAX) {
      lErrors.push(
        translate
          ? translate('new_post_errors.linkedin.alt_text_too_long', 'Alt text {{index}} exceeds the maximum character limit of {{maxLength}}.', {
              index: i + 1,
              maxLength: linkedinPostConfiguration.ALTER_TEXT_MAX,
            })
          : `Alt text ${i + 1} exceeds the maximum character limit of ${linkedinPostConfiguration.ALTER_TEXT_MAX}.`
      );
    }
  }
  return lErrors;
};

const GbusinessStandardConditions = (request, translate) => {
  let gErrors = [];
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('IMAGE')).length > 1;

  if (isMultipleVideoFiles) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.multiple_images', "You can't post multiple images.")
        : "You can't post multiple images."
    );
  } else {
    let videoFile = request.media_data?.some((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.no_videos', "You can't post videos.")
          : "You can't post videos."
      );
    }
  }

  if (request.button_type !== 'None' && request.button_type !== 'CALL') {
    if (!request.url) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.no_button_url', 'Please enter a Button URL.')
          : 'Please enter a Button URL.'
      );
    } else if (!CommonHelper.isValidUrl(request.url)) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.invalid_button_url', 'Please enter a valid Button URL.')
          : 'Please enter a valid Button URL.'
      );
    }
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }

  request.media_data?.forEach((media) => {
    if (media.media_type === 'IMAGE') {
      let { width, height } = media.aspect_ratio || {};
      if (
        width < gbusinessPostConfiguration.MINWIDTH ||
        height < gbusinessPostConfiguration.MINHEIGHT ||
        width > gbusinessPostConfiguration.MAXWIDTH ||
        height > gbusinessPostConfiguration.MAXHEIGHT
      ) {
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.invalid_image_dimensions', 'Image dimensions must be between {{minWidth}}x{{minHeight}} and {{maxWidth}}x{{maxHeight}} pixels. Current dimensions: {{width}}x{{height}}.', {
                minWidth: gbusinessPostConfiguration.MINWIDTH,
                minHeight: gbusinessPostConfiguration.MINHEIGHT,
                maxWidth: gbusinessPostConfiguration.MAXWIDTH,
                maxHeight: gbusinessPostConfiguration.MAXHEIGHT,
                width,
                height,
              })
            : `Image dimensions must be between ${gbusinessPostConfiguration.MINWIDTH}x${gbusinessPostConfiguration.MINHEIGHT} and ${gbusinessPostConfiguration.MAXWIDTH}x${gbusinessPostConfiguration.MAXHEIGHT} pixels. Current dimensions: ${width}x${height}.`
        );
      }
      if (media?.file_size !== 0 && media?.file_size > gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        const size = (media.file_size / 1024 / 1024).toFixed(2);
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.image_max_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                maxSize: gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB,
                size,
              })
            : `Image size must be less than ${gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
        );
      }
      if (media?.file_size !== 0 && media?.file_size < gbusinessPostConfiguration.MIN_IMAGE_SIZE_KB * 1024) {
        const size = (media.file_size / 1024).toFixed(2);
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.image_min_size', 'Image size must be at least {{minSize}} KB. Your image is {{size}} KB.', {
                minSize: gbusinessPostConfiguration.MIN_IMAGE_SIZE_KB,
                size,
              })
            : `Image size must be at least ${gbusinessPostConfiguration.MIN_IMAGE_SIZE_KB} KB. Your image is ${size} KB.`
        );
      }
    }
  });

  if (request.description && request.description.length > 1500) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.description_too_long', 'Character count cannot exceed 1500 characters for Google Business Profile description.')
        : 'Character count cannot exceed 1500 characters for Google Business Profile description.'
    );
  }
  if (request.title && request.title.length >= 58) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.title_too_long', 'Character count cannot exceed 58 characters for Google Business Profile title.')
        : 'Character count cannot exceed 58 characters for Google Business Profile title.'
    );
  }

  return gErrors;
};

const GbusinessEventConditions = (request, translate) => {
  let gErrors = [];
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('IMAGE')).length > 1;

  if (isMultipleVideoFiles) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.multiple_images', "You can't post multiple images.")
        : "You can't post multiple images."
    );
  } else {
    let videoFile = request.media_data?.some((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.no_videos', "You can't post videos.")
          : "You can't post videos."
      );
    }
  }

  if (!request.title) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.no_event_title', 'Please enter the Event title.')
        : 'Please enter the Event title.'
    );
  }

  if (request.button_type !== 'None' && request.button_type !== 'CALL') {
    if (!request.url) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.no_button_url', 'Please enter a Button URL.')
          : 'Please enter a Button URL.'
      );
    } else if (!CommonHelper.isValidUrl(request.url)) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.invalid_button_url', 'Please enter a valid Button URL.')
          : 'Please enter a valid Button URL.'
      );
    }
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }

  const startDateTime = dayjs(request.start_date)
    .set('hour', dayjs(request.start_time).hour())
    .set('minute', dayjs(request.start_time).minute());
  const endDateTime = dayjs(request.end_date)
    .set('hour', dayjs(request.end_time).hour())
    .set('minute', dayjs(request.end_time).minute());
  if (startDateTime.isAfter(endDateTime)) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.invalid_date_time', 'Start Date & Time must be earlier than End Date & Time.')
        : 'Start Date & Time must be earlier than End Date & Time.'
    );
  }

  request.media_data?.forEach((media) => {
    if (media.media_type === 'IMAGE') {
      let { width, height } = media.aspect_ratio || {};
      if (
        width < gbusinessPostConfiguration.MINWIDTH ||
        height < gbusinessPostConfiguration.MINHEIGHT ||
        width > gbusinessPostConfiguration.MAXWIDTH ||
        height > gbusinessPostConfiguration.MAXHEIGHT
      ) {
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.invalid_image_dimensions', 'Image dimensions must be between {{minWidth}}x{{minHeight}} and {{maxWidth}}x{{maxHeight}} pixels. Current dimensions: {{width}}x{{height}}.', {
                minWidth: gbusinessPostConfiguration.MINWIDTH,
                minHeight: gbusinessPostConfiguration.MINHEIGHT,
                maxWidth: gbusinessPostConfiguration.MAXWIDTH,
                maxHeight: gbusinessPostConfiguration.MAXHEIGHT,
                width,
                height,
              })
            : `Image dimensions must be between ${gbusinessPostConfiguration.MINWIDTH}x${gbusinessPostConfiguration.MINHEIGHT} and ${gbusinessPostConfiguration.MAXWIDTH}x${gbusinessPostConfiguration.MAXHEIGHT} pixels. Current dimensions: ${width}x${height}.`
        );
      }
      if (media?.file_size !== 0 && media?.file_size > gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        const size = (media.file_size / 1024 / 1024).toFixed(2);
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.image_max_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                maxSize: gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB,
                size,
              })
            : `Image size must be less than ${gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
        );
      }
    }
  });

  if (request.description && request.description.length > 1500) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.description_too_long', 'Character count cannot exceed 1500 characters for Google Business Profile description.')
        : 'Character count cannot exceed 1500 characters for Google Business Profile description.'
    );
  }
  if (request.title && request.title.length >= 58) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.title_too_long', 'Character count cannot exceed 58 characters for Google Business Profile title.')
        : 'Character count cannot exceed 58 characters for Google Business Profile title.'
    );
  }

  return gErrors;
};

const GbusinessOfferConditions = (request, translate) => {
  let gErrors = [];
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('IMAGE')).length > 1;

  if (isMultipleVideoFiles) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.multiple_images', "You can't post multiple images.")
        : "You can't post multiple images."
    );
  } else {
    let videoFile = request.media_data?.some((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      gErrors.push(
        translate
          ? translate('new_post_errors.gbusiness.no_videos', "You can't post videos.")
          : "You can't post videos."
      );
    }
  }

  if (!request.title) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.no_offer_title', 'Please enter the Offer title.')
        : 'Please enter the Offer title.'
    );
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }

  const startDateTime = dayjs(request.start_date)
    .tz(brandTimeZone, true)
    .set('hour', dayjs(request.start_time).hour())
    .set('minute', dayjs(request.start_time).minute());
  const endDateTime = dayjs(request.end_date)
    .tz(brandTimeZone, true)
    .set('hour', dayjs(request.end_time).hour())
    .set('minute', dayjs(request.end_time).minute());
  if (startDateTime.isAfter(endDateTime)) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.invalid_date_time', 'Start Date & Time must be earlier than End Date & Time.')
        : 'Start Date & Time must be earlier than End Date & Time.'
    );
  }

  request.media_data?.forEach((media) => {
    if (media.media_type === 'IMAGE') {
      let { width, height } = media.aspect_ratio || {};
      if (
        width < gbusinessPostConfiguration.MINWIDTH ||
        height < gbusinessPostConfiguration.MINHEIGHT ||
        width > gbusinessPostConfiguration.MAXWIDTH ||
        height > gbusinessPostConfiguration.MAXHEIGHT
      ) {
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.invalid_image_dimensions', 'Image dimensions must be between {{minWidth}}x{{minHeight}} and {{maxWidth}}x{{maxHeight}} pixels. Current dimensions: {{width}}x{{height}}.', {
                minWidth: gbusinessPostConfiguration.MINWIDTH,
                minHeight: gbusinessPostConfiguration.MINHEIGHT,
                maxWidth: gbusinessPostConfiguration.MAXWIDTH,
                maxHeight: gbusinessPostConfiguration.MAXHEIGHT,
                width,
                height,
              })
            : `Image dimensions must be between ${gbusinessPostConfiguration.MINWIDTH}x${gbusinessPostConfiguration.MINHEIGHT} and ${gbusinessPostConfiguration.MAXWIDTH}x${gbusinessPostConfiguration.MAXHEIGHT} pixels. Current dimensions: ${width}x${height}.`
        );
      }
      if (media?.file_size !== 0 && media?.file_size > gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        const size = (media.file_size / 1024 / 1024).toFixed(2);
        gErrors.push(
          translate
            ? translate('new_post_errors.gbusiness.image_max_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                maxSize: gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB,
                size,
              })
            : `Image size must be less than ${gbusinessPostConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
        );
      }
    }
  });

  if (request.description && request.description.length > 1500) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.description_too_long', 'Character count cannot exceed 1500 characters for Google Business Profile description.')
        : 'Character count cannot exceed 1500 characters for Google Business Profile description.'
    );
  }
  if (request.title && request.title.length >= 58) {
    gErrors.push(
      translate
        ? translate('new_post_errors.gbusiness.title_too_long', 'Character count cannot exceed 58 characters for Google Business Profile title.')
        : 'Character count cannot exceed 58 characters for Google Business Profile title.'
    );
  }

  return gErrors;
};

const TiktokDirectPostConditions = (request, translate) => {
  let fErrors = [];

  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('VIDEO'))?.length > 1;
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isMultipleImageFiles = request.media_data?.filter((a) => a.media_type.includes('IMAGE'))?.length > 1;
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');

  if (isImageFileAvailable && isVideoFileAvailable) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.mixed_media', "You can't post both an image and a video in the same post.")
        : "You can't post both an image and a video in the same post."
    );
  }
  if (isMultipleVideoFiles) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.multiple_videos', "You can't post multiple videos.")
        : "You can't post multiple videos."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length > tiktokPostConfiguration.VIDEO.MAXSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.max_video_length', 'Maximum video length for the post is {{maxSeconds}} seconds. Please choose a video with a maximum length of {{maxSeconds}} seconds.', {
                maxSeconds: tiktokPostConfiguration.VIDEO.MAXSECONDS,
              })
            : `Maximum video length for the post is ${tiktokPostConfiguration.VIDEO.MAXSECONDS} seconds. Please choose a video with a maximum length of ${tiktokPostConfiguration.VIDEO.MAXSECONDS} seconds.`
        );
      }

      if (videoFile.video_length < tiktokPostConfiguration.VIDEO.MINSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.min_video_length', 'Minimum video length for the post is {{minSeconds}} seconds. Please choose a video with at least {{minSeconds}} seconds.', {
                minSeconds: tiktokPostConfiguration.VIDEO.MINSECONDS,
              })
            : `Minimum video length for the post is ${tiktokPostConfiguration.VIDEO.MINSECONDS} seconds. Please choose a video with at least ${tiktokPostConfiguration.VIDEO.MINSECONDS} seconds.`
        );
      }

      if (
        videoFile.aspect_ratio.width < tiktokPostConfiguration.VIDEO.MINWIDTH ||
        videoFile.aspect_ratio.height < tiktokPostConfiguration.VIDEO.MINHEIGHT
      ) {
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.video_min_resolution', 'Video resolution is too low. Minimum resolution should be {{minWidth}}x{{minHeight}}.', {
                minWidth: tiktokPostConfiguration.VIDEO.MINWIDTH,
                minHeight: tiktokPostConfiguration.VIDEO.MINHEIGHT,
              })
            : `Video resolution is too low. Minimum resolution should be ${tiktokPostConfiguration.VIDEO.MINWIDTH}x${tiktokPostConfiguration.VIDEO.MINHEIGHT}.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > tiktokPostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.video_max_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: tiktokPostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${tiktokPostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    }
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }
  if (!hasAttachments) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.no_media', 'Please select any video or image.')
        : 'Please select any video or image.'
    );
  }
  if (isImageFileAvailable) {
    request.media_data.forEach((imageFile) => {
      if (imageFile.media_type === 'IMAGE') {
        let imageFileType = CommonHelper.GetFileTypeFromUrl(imageFile.media_url);
        if (imageFileType && imageFileType.toLowerCase() === 'png') {
          fErrors.push(
            translate
              ? translate('new_post_errors.tiktok.no_png', 'TikTok does not support PNG images.')
              : 'TikTok does not support PNG images.'
          );
        } else {
          if (
            imageFile.aspect_ratio.width < tiktokPostConfiguration.IMAGE.MINWIDTH ||
            imageFile.aspect_ratio.height < tiktokPostConfiguration.IMAGE.MINHEIGHT
          ) {
            fErrors.push(
              translate
                ? translate('new_post_errors.tiktok.image_min_resolution', 'Image resolution is too low. Minimum resolution should be 360x360 pixels.')
                : 'Image resolution is too low. Minimum resolution should be 360x360 pixels.'
            );
          }
          if (
            (imageFile.aspect_ratio.width > 1080 || imageFile.aspect_ratio.height > 1920) &&
            (imageFile.aspect_ratio.width > 1920 || imageFile.aspect_ratio.height > 1080)
          ) {
            fErrors.push(
              translate
                ? translate('new_post_errors.tiktok.image_max_resolution', 'Image resolution is too high. Maximum resolution should be 1080x1920 or 1920x1080 pixels.')
                : 'Image resolution is too high. Maximum resolution should be 1080x1920 or 1920x1080 pixels.'
            );
          }
          if (
            imageFile?.file_size !== 0 &&
            imageFile?.file_size > tiktokPostConfiguration.IMAGE.FILESIZE * 1024 * 1024
          ) {
            const size = (imageFile.file_size / 1024 / 1024).toFixed(2);
            fErrors.push(
              translate
                ? translate('new_post_errors.tiktok.image_max_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                    maxSize: tiktokPostConfiguration.IMAGE.FILESIZE,
                    size,
                  })
                : `Image size must be less than ${tiktokPostConfiguration.IMAGE.FILESIZE} MB. Your image is ${size} MB.`
            );
          }
        }
      }
    });
  }
  let imageFiles = request.media_data?.filter((a) => a.media_type === 'IMAGE');
  if (imageFiles?.length > tiktokPostConfiguration.IMAGE.MAXIMAGECOUNT) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.max_images', 'You can upload a maximum of {{maxCount}} images. Please remove some images.', {
            maxCount: tiktokPostConfiguration.IMAGE.MAXIMAGECOUNT,
          })
        : `You can upload a maximum of ${tiktokPostConfiguration.IMAGE.MAXIMAGECOUNT} images. Please remove some images.`
    );
  }
  if (request.description && request.description.length > tiktokPostConfiguration.DESCRIPTION_MAX) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.description_too_long', 'TikTok description should not exceed 2200 characters.')
        : 'TikTok description should not exceed 2200 characters.'
    );
  }
  if (request.title && request.title.length > tiktokPostConfiguration.TITLE_MAX) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.title_too_long', 'TikTok title should not exceed 90 characters.')
        : 'TikTok title should not exceed 90 characters.'
    );
  }

  return fErrors;
};

const TiktokUploadToInboxConditions = (request, translate) => {
  let fErrors = [];

  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('VIDEO'))?.length > 1;
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');

  if (isVideoFileAvailable) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.no_videos_inbox', "You can't upload a video to the inbox.")
        : "You can't upload a video to the inbox."
    );
  }
  if (isMultipleVideoFiles) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.multiple_videos', "You can't post multiple videos.")
        : "You can't post multiple videos."
    );
  } else {
    let videoFile = request.media_data?.find((a) => a.media_type === 'VIDEO');
    if (videoFile) {
      if (videoFile.video_length > tiktokPostConfiguration.VIDEO.MAXSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.max_video_length', 'Maximum video length for the post is {{maxSeconds}} seconds. Please choose a video with a maximum length of {{maxSeconds}} seconds.', {
                maxSeconds: tiktokPostConfiguration.VIDEO.MAXSECONDS,
              })
            : `Maximum video length for the post is ${tiktokPostConfiguration.VIDEO.MAXSECONDS} seconds. Please choose a video with a maximum length of ${tiktokPostConfiguration.VIDEO.MAXSECONDS} seconds.`
        );
      }

      if (videoFile.video_length < tiktokPostConfiguration.VIDEO.MINSECONDS) {
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.min_video_length', 'Minimum video length for the post is {{minSeconds}} seconds. Please choose a video with at least {{minSeconds}} seconds.', {
                minSeconds: tiktokPostConfiguration.VIDEO.MINSECONDS,
              })
            : `Minimum video length for the post is ${tiktokPostConfiguration.VIDEO.MINSECONDS} seconds. Please choose a video with at least ${tiktokPostConfiguration.VIDEO.MINSECONDS} seconds.`
        );
      }

      if (
        videoFile.aspect_ratio.width < tiktokPostConfiguration.VIDEO.MINWIDTH ||
        videoFile.aspect_ratio.height < tiktokPostConfiguration.VIDEO.MINHEIGHT
      ) {
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.video_min_resolution', 'Video resolution is too low. Minimum resolution should be {{minWidth}}x{{minHeight}}.', {
                minWidth: tiktokPostConfiguration.VIDEO.MINWIDTH,
                minHeight: tiktokPostConfiguration.VIDEO.MINHEIGHT,
              })
            : `Video resolution is too low. Minimum resolution should be ${tiktokPostConfiguration.VIDEO.MINWIDTH}x${tiktokPostConfiguration.VIDEO.MINHEIGHT}.`
        );
      }
      if (
        videoFile?.file_size !== 0 &&
        videoFile?.file_size > tiktokPostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024
      ) {
        const size = (videoFile.file_size / 1024 / 1024).toFixed(2);
        fErrors.push(
          translate
            ? translate('new_post_errors.tiktok.video_max_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: tiktokPostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${tiktokPostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    }
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments && !request.description) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.no_description', 'Please enter a description.')
        : 'Please enter a description.'
    );
  }
  if (!hasAttachments) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.no_media', 'Please select any video or image.')
        : 'Please select any video or image.'
    );
  }
  if (isImageFileAvailable) {
    request.media_data.forEach((imageFile) => {
      if (imageFile.media_type === 'IMAGE') {
        let imageFileType = CommonHelper.GetFileTypeFromUrl(imageFile.media_url);
        if (imageFileType && imageFileType.toLowerCase() === 'png') {
          fErrors.push(
            translate
              ? translate('new_post_errors.tiktok.no_png', 'TikTok does not support PNG images.')
              : 'TikTok does not support PNG images.'
          );
        } else {
          if (
            imageFile.aspect_ratio.width < tiktokPostConfiguration.IMAGE.MINWIDTH ||
            imageFile.aspect_ratio.height < tiktokPostConfiguration.IMAGE.MINHEIGHT
          ) {
            fErrors.push(
              translate
                ? translate('new_post_errors.tiktok.image_min_resolution', 'Image resolution is too low. Minimum resolution should be 360x360 pixels.')
                : 'Image resolution is too low. Minimum resolution should be 360x360 pixels.'
            );
          }
          if (
            (imageFile.aspect_ratio.width >= 1080 || imageFile.aspect_ratio.height >= 1920) &&
            (imageFile.aspect_ratio.width >= 1920 || imageFile.aspect_ratio.height >= 1080)
          ) {
            fErrors.push(
              translate
                ? translate('new_post_errors.tiktok.image_max_resolution', 'Image resolution is too high. Maximum resolution should be 1080x1920 or 1920x1080 pixels.')
                : 'Image resolution is too high. Maximum resolution should be 1080x1920 or 1920x1080 pixels.'
            );
          }
        }
      }
    });
  }
  let imageFiles = request.media_data?.filter((a) => a.media_type === 'IMAGE');
  if (imageFiles?.length > tiktokPostConfiguration.IMAGE.MAXIMAGECOUNT) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.max_images', 'You can upload a maximum of {{maxCount}} images. Please remove some images.', {
            maxCount: tiktokPostConfiguration.IMAGE.MAXIMAGECOUNT,
          })
        : `You can upload a maximum of ${tiktokPostConfiguration.IMAGE.MAXIMAGECOUNT} images. Please remove some images.`
    );
  }
  if (request.description && request.description.length > tiktokPostConfiguration.DESCRIPTION_MAX) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.description_too_long', 'TikTok description should not exceed 2200 characters.')
        : 'TikTok description should not exceed 2200 characters.'
    );
  }
  if (request.title && request.title.length > tiktokPostConfiguration.TITLE_MAX) {
    fErrors.push(
      translate
        ? translate('new_post_errors.tiktok.title_too_long', 'TikTok title should not exceed 90 characters.')
        : 'TikTok title should not exceed 90 characters.'
    );
  }

  return fErrors;
};

const PinterestPostConditions = (request, isOrgConnectedProfilesData = false, translate) => {
  let pErrors = [];
  let isImageFileAvailable = request.media_data?.some((a) => a.media_type === 'IMAGE');
  let isVideoFileAvailable = request.media_data?.some((a) => a.media_type === 'VIDEO');
  let isMultipleVideoFiles = request.media_data?.filter((a) => a.media_type.includes('VIDEO'))?.length > 1;

  if (isMultipleVideoFiles) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.multiple_videos', "You can't post multiple videos.")
        : "You can't post multiple videos."
    );
  }

  let isMultipleImageFiles = request.media_data?.filter((a) => a.media_type.includes('IMAGE'))?.length > 1;
  if (isMultipleImageFiles) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.multiple_images', "You can't post multiple images.")
        : "You can't post multiple images."
    );
  }

  if (isImageFileAvailable && isVideoFileAvailable) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.mixed_media', "You can't post both an image and a video in the same post.")
        : "You can't post both an image and a video in the same post."
    );
  }

  let hasAttachments = request.media_data?.length > 0;
  if (!hasAttachments) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.no_media', 'Please select any video or image.')
        : 'Please select any video or image.'
    );
  }

  let isBoardIdCreated = request.board_id === '' && !isOrgConnectedProfilesData;
  if (isBoardIdCreated) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.no_board', 'You must create a Board.')
        : 'You must create a Board.'
    );
  }

  let isLinkEnters = request.link?.length > 0;
  if (isLinkEnters && !CommonHelper.isValidUrl(request.link)) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.invalid_url', 'Please enter a valid URL.')
        : 'Please enter a valid URL.'
    );
  }
  if (request.description && request.description.length > pinterestPostConfiguration.DESCRIPTION_MAX) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.description_too_long', 'Pinterest description should not exceed 800 characters.')
        : 'Pinterest description should not exceed 800 characters.'
    );
  }
  if (request.title && request.title.length > pinterestPostConfiguration.TITLE_MAX) {
    pErrors.push(
      translate
        ? translate('new_post_errors.pinterest.title_too_long', 'Pinterest title should not exceed 100 characters.')
        : 'Pinterest title should not exceed 100 characters.'
    );
  }
  request?.media_data?.forEach((media) => {
    if (media.media_type === 'IMAGE') {
      if (media?.file_size !== 0 && media?.file_size > pinterestPostConfiguration.MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        const size = (media.file_size / 1024 / 1024).toFixed(2);
        pErrors.push(
          translate
            ? translate('new_post_errors.pinterest.image_max_size', 'Image size must be less than {{maxSize}} MB. Your image is {{size}} MB.', {
                maxSize: pinterestPostConfiguration.MAX_IMAGE_SIZE_MB,
                size,
              })
            : `Image size must be less than ${pinterestPostConfiguration.MAX_IMAGE_SIZE_MB} MB. Your image is ${size} MB.`
        );
      }
    } else {
      if (media?.file_size !== 0 && media?.file_size > pinterestPostConfiguration.MAX_VIDEO_SIZE_MB * 1024 * 1024) {
        const size = (media.file_size / 1024 / 1024).toFixed(2);
        pErrors.push(
          translate
            ? translate('new_post_errors.tiktok.video_max_size', 'Video size must be less than {{maxSize}} MB. Your video is {{size}} MB.', {
                maxSize: tiktokPostConfiguration.MAX_VIDEO_SIZE_MB,
                size,
              })
            : `Video size must be less than ${tiktokPostConfiguration.MAX_VIDEO_SIZE_MB} MB. Your video is ${size} MB.`
        );
      }
    }
  });

  let isCoverImageAvailable = request?.cover_image_url;
  if (isVideoFileAvailable) {
    if (!isCoverImageAvailable) {
      pErrors.push(
        translate
          ? translate('new_post_errors.pinterest.no_cover_image', 'Please choose the cover image.')
          : 'Please choose the cover image.'
      );
    } else if (!CommonHelper.isValidImageUrl(isCoverImageAvailable)) {
      pErrors.push(
        translate
          ? translate('new_post_errors.pinterest.invalid_cover_image', 'Please enter a valid cover image URL.')
          : 'Please enter a valid cover image URL.'
      );
    }
  }

  return pErrors;
};

export const NewPostErrorUtil = {
  FacebookPostConditions,
  FacebookReelsConditions,
  FacebookStoryConditions,
  InstagramPostConditions,
  InstagramReelsConditions,
  InstagramStoryConditions,
  TwitterPostConditions,
  YoutubePostConditions,
  YoutubeShortsConditions,
  LinkedinPostConditions,
  GbusinessStandardConditions,
  GbusinessEventConditions,
  GbusinessOfferConditions,
  TiktokDirectPostConditions,
  TiktokUploadToInboxConditions,
  PinterestPostConditions,
  FacebookBulkUploadConditions,
  InstagramBulkUploadConditions,
  YoutubeBulkUploadConditions,
  TiktokBulkUploadConditions,
  GbusinessBulkUploadConditions,
  PinterestBulkUploadConditions,
  LinkedinBulkUploadConditions,
  TwitterBulkUploadConditions,
  ThreadsPostConditions,
  BlueskyPostConditions,
  BlueskyBulkUploadConditions,
  ThreadsBulkUploadConditions,
  SnapChatSpotlightConditions,
  SnapChatSavedStoryConditions,
  SnapChatPublicStoryConditions,
  SnapChatBulkUploadConditions
};
